import $ from 'jquery';

(() => {
  class Meganav {
    constructor() {
      this.meganav = document.querySelector('#meganav');
      document.addEventListener('click', this.onClick.bind(this))
    }

    isOpen() {
      return this.meganav.querySelectorAll('.meganav-panel.show').length > 0;
    }

    onClick(evt) {
      if (!evt.target.matches('.meganav-toggle') && evt.target.closest('#meganav') === null) {
        $('.header-meganav .meganav-panel.show').collapse('hide');
      }
      if (evt.target.closest('.modal-content') === null) {
        $('#mobile-nav .meganav-panel.show').collapse('hide');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    let meganav = new Meganav();
  })
})()